import * as angular from 'angular';
import * as CodeMirror from 'codemirror';

import { ComponentDefinition } from '../../models';

class MarkdownEditorController implements angular.IComponentController {
    model: string;

    editor: CodeMirror.Editor;
    codeMirrorOptions = {
        'firstLineNumber': 1,
        'matchBrackets': true,
        'autoCloseBrackets': true,
        'lineWrapping': true,
        'lineNumbers': true,
        'mode': 'gfm',
        'theme': 'xq-light',
        'readOnly': false,
        'styleActiveLine': true,
        'autoRefresh': true,
        highlightFormatting: true
    };

    static $inject = [];
    constructor() {
        this.codemirrorLoaded = this.codemirrorLoaded.bind(this);
    }

    codemirrorLoaded(editor: CodeMirror.Editor) {
        this.editor = editor;
    }
}

export const wtMarkdownEditor: ComponentDefinition = {
    componentId: 'wtMarkdownEditor',
    controller: MarkdownEditorController,
    template: require('./codeMirrorMarkdownEditor.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        theme: '<'
    }
};
